import React, { createContext, useState, useEffect } from 'react';

// إنشاء سياق اللغة
export const LanguageContext = createContext();

// مزود سياق اللغة
export const LanguageProvider = ({ children }) => {
  // استعادة اللغة المختارة من localStorage أو تعيين 'ar' كافتراضية
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('language') || 'ar';
  });

  // عند تغيير اللغة، يتم حفظها في localStorage
  const toggleLanguage = () => {
    setLanguage((prevLanguage) => {
      const newLanguage = prevLanguage === 'ar' ? 'en' : 'ar';
      localStorage.setItem('language', newLanguage);
      return newLanguage;
    });
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
